import Path from 'webmango-utils/path'

import { createSelector, createStructuredSelector } from 'reselect'

import * as File from './file'
import * as Schema from './schema'
import * as Status from './status'
import * as Config from './config'
import * as RunSection from './runsection'
import { getArgN } from './utils'

export * from './utils'

export const getAll = createSelector([
  createStructuredSelector({
    dataDirectory: Config.getDataDirectory,
    schemas: Schema.getAll,
    allFiles: File.getAll,
    runSections: RunSection.getAll,
    statuses: Status.getAll,
    FileAPI: File.getAPI
  })
], ({ dataDirectory, schemas, allFiles, runSections, statuses, FileAPI }) => {
  return [...Object.entries(statuses)].reduce((updatedStatuses, [id, status]) => {
    const runSection = runSections[id] || {}
    const schema = schemas[status.schemaID]
    const files = _getRunFiles(dataDirectory, allFiles, runSection)
    let updatedStatus = Object.assign({}, status, {
      files,
      runSection,
      get parentStatus () {
        return status.parentStatus && updatedStatuses[status.parentStatus.id]
      },
      get inputFileType () {
        return this.parentStatus && this.parentStatus.outputFileType
      },
      get outputFileType () {
        const type = FileAPI.getExtensionFiletype(runSection.output_extension)
        return type && type.id
      },
      get hasInvalidFileType () {
        if (!runSection.input_file_name) return false
        if (schema.type === 'inputdata' || schema.id === 'inplace-import_data_file-0') {
          return false
        } else {
          return runSection.input_extension !== 'nc'
        }
      },
      get hasOutputFile () {
        return !!runSection.output_file_name
      },
      get outputFileExists () {
        return !!(this.hasOutputFile && files.output)
      },
      get outputFileCreate () {
        if (schema.type === 'analysis') return false
        if (!schema.isFilter) return false
        return !this.outputFileExists
      },
      get outputFileOverwrite () {
        if (schema.type === 'analysis') return false
        if (!schema.isFilter) return false
        return this.outputFileExists
      },
      get needsMissingFile () {
        if (schema.type === 'inputdata') return !files.input
        if (!schema.isFilter) return false
        if (!status.parentStatus) return false
        if (status.parentStatus.enabled) return false
        if (!status.enabled) return false
        if (files.input) return false
        return true
      },
      get missingFile () {
        if (!this.needsMissingFile) return
        if (runSection.input_file_name) return runSection.input_file_name
        if (this.parentStatus && this.parentStatus.runSection) {
          return this.parentStatus.runSection.output_file_name
        }
      }
    })

    updatedStatus = Status.setStatusFields(updatedStatus)
    return Object.assign(updatedStatuses, {
      [id]: updatedStatus
    })
  }, Object.assign({}, statuses))
})

export const get = createSelector([ getAll, getArgN(2) ], (runStatuses, nodeID) => {
  return runStatuses[nodeID]
})

function _getRunFiles (dataDirectory, files, runSection) {
  const dataFiles = files[dataDirectory] || []
  return Object.assign({}, {
    get input () {
      if (!runSection) return false
      const input = Path.join(dataDirectory, `${runSection.input_file_name}.${runSection.input_extension}`)
      const inputAlt = Path.join(dataDirectory, `${runSection.input_file_name}_${runSection.input_extension}`)
      return dataFiles.find(({ path }) => {
        return (
          path === input ||
          path === inputAlt
        )
      }) || false
    },
    get output () {
      if (!runSection) return false
      const output = Path.join(dataDirectory, `${runSection.output_file_name}.${runSection.output_extension}`)
      const outputAlt = Path.join(dataDirectory, `${runSection.output_file_name}_${runSection.output_extension}`)
      return dataFiles.find(({ path }) => {
        return (
          path === output ||
          path === outputAlt
        )
      }) || false
    }
  })
}



// WEBPACK FOOTER //
// ../webmango-core/selectors/runstatus.js